import { Injectable, signal } from '@angular/core';
import { IDictionaryItem } from '../interfaces/IDictionaryItem';
import { Dictionaries } from '../enums/Dictionaries';
import { ICurrency } from '../interfaces/ICurrency';

@Injectable({
  providedIn: 'root'
})
export class DictionariesStore {

  public readonly [Dictionaries.COUNTRIES] = signal<IDictionaryItem[]>([]);
  public readonly [Dictionaries.LANGUAGE] = signal<IDictionaryItem[]>([]);
  public readonly [Dictionaries.CURRENCIES] = signal<ICurrency[]>([]);
}
